const Laroute = require('../../laroute');

const state = {
    lastQuery: null,
    variantList: [],
    totalRecords: 0,
};

const mutations = {
    setVariantList(state, data) {
        state.variantList = data;
    },

    setTotalRecords(state, total) {
        state.totalRecords = total;
    },
};

const getters = {
    variantList(state) {
        return state.variantList;
    },

    totalRecords: state => state.totalRecords,
};

const actions = {
    async fetchVariants(context, params = {}) {
        const url = Laroute.route('franchise.vue.variants');
        const options = { params: Object.assign({ limit: 10 }, params) };

        try {
            const { data } = await axios.get(url, options);
            return data;
        } catch (e) {
            throw e;
        }
    },

    async getVariantList({ commit, dispatch }, params = {}) {
        try {
            const { data, count } = await dispatch('fetchVariants', params);
            commit('setVariantList', data);
            commit('setTotalRecords', count);
            return data;
        } catch (e) {
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
